<template>
  <div class="ma-4">
    <v-card v-if="!dataLoaded">
      <v-card-title>Academic Program/Advisor Change Form (Loading...)</v-card-title>
    </v-card>
    <change-status v-else-if="'program' in submission && submission.program.length > 0 && status !== 'Returned'" :submission="submission" :term-label="termLabel" @update="(data) => submission = data"></change-status>
    <template v-else>
      <v-toolbar>
        <v-toolbar-title>Academic Program/Advisor Change: {{ termLabel }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="mb-2">
        <v-card-text>
          <p>This is where you can view your current major(s), minor(s), concentration(s), and certificate(s), and submit change requests for them.</p>
          <p>You can request to change your advisor below. Please note that you might be assigned a different advisor based on if the requested advisor is going on sabbatical, or to keep the department's advising duties balanced between professors, or based on a system developed by the department of your major.</p>
        </v-card-text>
      </v-card>
      <v-row class="mt-2" v-if="programs.length > 0">
        <v-col :cols="12" :md="6" class="py-0">
          <v-card style="height:100%">
            <v-card-text class="pb-0">
              <v-list-item class="py-0">
                <v-list-item-content>
                  <v-list-item-subtitle>Major</v-list-item-subtitle>
                  <v-list-item-title>{{ getMajorDesc(programs[0].major) }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-dialog v-if="programs.length === 1" v-model="addMajorDialog" width="400">
                    <template #activator="{ on }">
                      <v-btn v-on="on" :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'add')" small style="width:105px">
                        <v-icon left>fal fa-plus-circle</v-icon>
                        Add
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>Add Major</v-card-title>
                      <v-card-text>
                        <v-autocomplete v-model="majorToAdd" :items="majorItems.filter(({ value }) => value !== programs[0].major)" label="Major to Add" outlined />
                        <v-select v-model="addAdvisor" :items="addAdvisorOptions" label="Requested Advisor" outlined />
                        <v-autocomplete v-model="addConcentrations" :disabled="addConcentrationOptions.length === 0" :items="addConcentrationOptions" label="Concentration(s)" outlined multiple />
                      </v-card-text>
                      <v-card-actions>
                        <v-btn :disabled="majorToAdd === '' || addAdvisor === ''" @click="addMajor()" text>Add Major</v-btn>
                        <v-spacer />
                        <v-btn text @click="addMajorDialog = false">Cancel</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn v-else :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'drop')" small style="width:105px">
                    <v-icon left>fal fa-minus-circle</v-icon>
                    Drop
                  </v-btn>
                  <v-dialog v-if="programs.length === 1" v-model="changeMajorDialog" width="400">
                    <template #activator="{ on }">
                      <v-btn v-on="on" :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'change')" small style="width:105px">
                        <v-icon left>fal fa-exchange</v-icon>
                        Change
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>Change Major</v-card-title>
                      <v-card-text>
                        <v-autocomplete v-model="changeMajorTo" :items="majorItems.filter(({ value }) => value !== programs[0].major)" label="Change Major to:" outlined hide-details />
                      </v-card-text>
                      <v-card-actions>
                        <v-btn @click="changeMajor()">Change Major</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer />
              <v-dialog v-if="programs.length === 1" v-model="addMajorDialog" width="400">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'add')" text small>
                    <v-icon left>fal fa-plus-circle</v-icon>
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>Add Major</v-card-title>
                  <v-card-text>
                    <v-autocomplete v-model="majorToAdd" :items="majorItems.filter(({ value }) => value !== programs[0].major)" label="Major to Add" outlined hide-details />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="addMajor()">Add Major</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn v-else :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'drop')" text small>
                <v-icon left>fal fa-minus-circle</v-icon>
                Drop Major
              </v-btn>
              <v-dialog v-if="programs.length === 1" v-model="addMajorDialog" width="400">
                <template #activator="{ on }">
                  <v-btn v-on="on" :disabled="!!changes.find(({ field, action }) => field === 'major' && action === 'change')" text small>
                    <v-icon left>fal fa-exchange</v-icon>
                    Change Major
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>Change Major</v-card-title>
                  <v-card-text>
                    <v-autocomplete v-model="majorToAdd" :items="majorItems.filter(({ value }) => value !== programs[0].major)" label="Change Major to:" outlined hide-details />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="addMajor()">Change Major</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions> -->
            <v-card-text>
              <v-list-item class="py-0">
                <v-list-item-content>
                  <v-list-item-subtitle>Advisor</v-list-item-subtitle>
                  <v-list-item-title>{{ programs[0].advisors.map(({ text }) => text).join('; ') }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small>
                    <v-icon left>fal fa-exchange</v-icon>
                    Change
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer />
              <v-btn text>Change Advisor</v-btn>
            </v-card-actions> -->
            <v-card-text>
              <v-list-item class="py-0">
                <v-list-item-content>
                  <v-list-item-subtitle>Concentration(s)</v-list-item-subtitle>
                  <v-list-item-title v-if="programs[0].concentration.length === 0">**No Concentrations Selected**</v-list-item-title>
                  <v-list-item-title v-for="{ text, value } of programs[0].concentration" :key="'conc-' + value">{{ text }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small>
                    <v-icon left>fal fa-exchange</v-icon>
                    Change
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer />
              <v-btn text>Change Concentrations</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-col>
        <v-col :cols="12" :md="6" class="py-0">
          <v-alert v-for="({ field, action, value, text }, index) of changes" :key="field + '-' + action" :type="action === 'add' ? 'success' : (action === 'drop' ? 'error' : 'info')">
            {{ action.substring(0, 1).toUpperCase() + action.substring(1) }} {{ field.substring(0, 1).toUpperCase() + field.substring(1) + (action === 'change' ? ' to' : '') }}: {{ text }}
            <template #append>
              <v-btn small @click="changes.splice(index, 1)">Cancel</v-btn>
            </template>
          </v-alert>
        </v-col>
      </v-row>
      <v-card v-if="includeP12 || isEDSTMajor" class="mb-2">
        <v-card-text>
          <h4>Education or Teacher Certification</h4>
          <template v-if="includeP12">
            <p>Students who desire to teach in a field from their selected major are encouraged to minor in Education followed by completion of the Master of Arts in Teaching degree at Covenant. Note: if you choose not to minor in Education, you are required to complete three pre-requisite education courses: Introduction to Teaching, Education Psychology, and Education of Exceptional Children.</p>
            <v-checkbox :value="P12Secondary" label="P-12 or Secondary (grades 6-12) Education - the five year secondary certification program including MAT degree" readonly />
          </template>
          <template v-if="isEDSTMajor">
            <p>Students who desire middle grades certification should complete the fifth-year Master of Arts in Teaching degree at Covenant. You must also select two content fields in the box below.</p>
            <v-list-item>
              <v-list-item-subtitle>Content Fields</v-list-item-subtitle>
              <v-list-item-title>{{ contentFieldItems.filter(({ value }) => EDSTContentFields.includes(value)).map(({ text }) => text).join('; ') }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-card-text>
      </v-card>
      <v-toolbar flat style="margin-bottom:40px" class="mt-4">
        <v-btn text to="/student" class="mr-2">Cancel</v-btn>
        <v-btn color="success" :disabled="!isValid" @click="save">Save</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="setInitialData()">Reset</v-btn>
      </v-toolbar>
    </template>
  </div>
</template>
<script>
import { ref, computed, reactive, watch, onMounted } from '@vue/composition-api'
import { inArray } from '@/helpers/functions'
import { advisors, concentrations, IDSPrimaryConcentrations } from '@/components/student/program-change/options'

export default {
  components: {
    changeStatus: () => import('@/components/student/program-change/status')
    // ProgramBlock: () => import('@/components/student/program-change/programBlock')
    // CertBlock: () => import('@/components/student/program-change/certBlock')
  },
  setup (props, { root }) {
    const service = root.$feathers.service('student/major-change')
    const settingServ = root.$feathers.service('student/reg-setting')

    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const roles = computed(() => root.$store.state.roles)
    const required = ref([(v) => !!v || 'Required'])
    const dataLoaded = ref(false)
    const term = ref('')
    const termLabel = ref('')

    const current = reactive({
      program: [],
      minor: [],
      p12: false,
      contentField: []
    })
    const changes = ref([])

    const submission = ref({})
    const status = computed(() => 'status' in submission.value ? submission.value.status : 'Unsubmitted')
    const original = reactive({})

    const programs = ref([])
    const majorItems = ref([])
    const addMajorDialog = ref(false)
    const majorToAdd = ref('')
    const addAdvisor = ref('')
    const addAdvisorOptions = ref([])
    const addConcentrations = ref([])
    const addConcentrationOptions = ref([])
    watch(majorToAdd, async () => {
      if (majorToAdd.value) {
        const { data } = await settingServ.find({ query: { form: 'program', category: 'advisor', major: majorToAdd.value, $sort: { term: -1 }, $limit: 1 } })
        if (data.length === 0) {
          alert('There was an error loading the advisors for the selected major. Please contact the Records office for assistance.')
          return
        } else {
          addAdvisorOptions.value = data[0].options
        }
        const { data: concData } = await settingServ.find({ query: { form: 'program', category: 'concentration', major: majorToAdd.value, $sort: { term: -1 }, $limit: 1 } })
        if (concData.length === 0) {
          alert('There was an error loading the concentrations for the selected major. Please contact the Records office for assistance.')
        } else {
          addConcentrationOptions.value = concData[0].options
        }
      }
    })
    function addMajor () {
      const temp = majorItems.value.find(({ value }) => majorToAdd.value === value)
      changes.value.push({ field: 'major', action: 'add', value: majorToAdd.value, text: temp.text || majorToAdd.value })
      addMajorDialog.value = false
    }

    const changeMajorDialog = ref(false)
    const changeMajorTo = ref('')
    function changeMajor () {
      const temp = majorItems.value.find(({ value }) => changeMajorTo.value === value)
      changes.value.push({ field: 'major', action: 'change', value: changeMajorTo.value, text: temp.text || changeMajorTo.value })
      changeMajorDialog.value = false
    }

    const primaryItems = computed(() => IDSPrimaryConcentrations)

    const minor = ref([])
    const minorItems = ref([])
    watch(minor, () => {
      if (minor.value.length > 2) {
        minor.value.splice(2, 1)
      }
    })

    onMounted(async () => {
      if ('Records' in roles.value || 'Employee' in roles.value || 'All Adjuncts' in roles.value || 'Technology Services' in roles.value) {
        root.$router.replace('/student/program-change/admin')
        return
      }
      // Load the major options
      settingServ.find({ query: { form: 'program', category: 'major', $sort: { term: -1 }, $limit: 1 } }).then(({ data }) => {
        majorItems.value = data[0].options
      })
      // Load the minor options
      settingServ.find({ query: { form: 'program', category: 'minor', $sort: { term: -1 }, $limit: 1 } }).then(({ data }) => {
        minorItems.value = data[0].options
      })
      // Get possible terms from the term warehouse; all terms that have not yet ended
      let { data: termData } = await root.$feathers.service('system/term').find({ query: { end: { $gt: new Date() }, $limit: 50 } })
      let terms = []
      for (let i = 0; i < termData.length; i++) {
        terms.push(termData[i].term)
      }
      // Load the PIDM of the current user
      let pidm = user.value.pidm
      // Check to see if the student has a submission for any of the given terms; if so, we will use that to populate the submission and the original data, in the case where they are making further changes
      const { data: changeData } = await service.find({ query: { pidm, term: { $in: terms } } })
      if (changeData.length > 0) {
        submission.value = changeData[0]
        if (status.value === 'Submitted' || status.value === 'Pending' || status.value === 'Approved') {
          dataLoaded.value = true
          return
        }
      }
      // Load the student's academic data from the student/term-detail for any of the active or future terms, sorted with the term code ascending
      // This will load the current term first, if there is a record for it, or for the next term to begin
      let { data: studentData } = await root.$feathers.service('student/term-detail').find({ query: { pidm, term: { $in: terms }, $sort: { term: 1 } } })
      if (studentData.length > 0) {
        let { academics, term: termCode } = studentData[0]
        term.value = termCode
        const { data: termData } = await root.$feathers.service('system/term').find({ query: { term: termCode } })
        if (termData.length > 0) termLabel.value = termData[0].label
        for (let l in academics) {
          if (Array.isArray(academics[l])) original[l] = academics[l].filter((val) => val !== '')
          else original[l] = academics[l]
        }
        console.log(academics)
        setInitialData(academics)
        dataLoaded.value = true
      } else {
        root.$store.dispatch('main/snackbar', { active: true, color: 'error', timeout: 10000, text: 'No enrollment details were found for you in any active term. Please contact the Records office for assistance.' })
        root.$router.replace('/')
      }
    })

    async function setInitialData ({ major, minor, concentration, advisor }) {
      programs.value = []

      for (const maj of major) {
        const prog = {
          major: maj,
          advisors: [],
          concentration: []
        }
        const { data } = await settingServ.find({ query: { form: 'program', major: maj, $sort: { category: 1, term: -1 } } })
        for (const { category, options } of data) {
          if (category === 'advisor') {
            // Find any major advisors in the advisor list and match them to what's in the options list
            prog.advisors = options.filter(({ value }) => advisor.find(({ code, pidm }) => code === 'MAJR' && pidm === value))
          } else if (category === 'concentration') {
            prog.concentration = options.filter(({ value }) => concentration.includes(value))
          }
        }
        programs.value.push(prog)
      }
      console.log(programs.value)
    }

    async function save () {
      if (form.value.validate()) {
        console.log('Form is valid')
      }
      const obj = {
        term: term.value,
        pidm: user.value.pidm,
        bannerId: user.value.bannerId,
        name: user.value.name,
        status: 'Submitted',
        program: programs.value,
        minor: minor.value,
        p12: P12Secondary.value,
        contentFields: EDSTContentFields.value
      }
      const timeline = {
        pidm: user.value.pidm,
        name: user.value.name,
        date: new Date(),
        text: 'Request Submitted',
        icon: 'fal fa-save',
        color: 'info',
        visibleToStudent: true
      }
      console.log(obj)
      let { data } = await service.find({ query: { term: term.value, pidm: user.value.pidm } })
      if (data.length > 0) {
        obj.$push = { timeline }
        await service.patch(data[0]._id, obj)
      } else {
        obj.timeline = [timeline]
        await service.create(obj)
      }
      await root.$feathers.service('system/email').create({
        from: { email: 'report-email@covenant.edu', name: 'Program Change' },
        to: 'recordsoffice@covenant.edu',
        subject: 'Program/Advisor Change Submitted',
        html: user.value.preferred + ' ' + user.value.last + ' has submitted a program/advisor change. Please click on the link below to access the Program/Advisor Change system to review this request.<br/><br/><a href="https://portal.covenant.edu/student/program-change">https://portal.covenant.edu/student/program-change</a>'
      })
      root.$store.dispatch('main/snackbar', { active: true, color: 'success', timeout: 6000, text: 'Your program/advisor change form was submitted successfully.' })
      root.$router.push('/student/program-change/status')
    }

    /** Education add-ons */
    const eduMajors = {
      ART: true,
      BIB: true,
      BIO: true,
      CHE: true,
      COS: true,
      ECO: true,
      ENG: true,
      FRE: true,
      GER: true,
      HIS: true,
      MAT: true,
      MUS: true,
      PHY: true,
      POLS: true,
      SPA: true,
      THET: true
    }
    const includeP12 = computed(() => programs.value.reduce((prev, { major }) => prev || major in eduMajors, false))
    const P12Secondary = ref(false)
    watch(P12Secondary, (val) => {
      if (val && !minor.value.reduce((prev, minr) => prev || minr === 'EDU', false)) {
        minor.value.push('EDU')
      }
    }, {
      lazy: true
    })
    watch(minor, () => {
      if (P12Secondary.value && !inArray('EDU', minor.value)) {
        P12Secondary.value = false
      }
    })

    const isEDSTMajor = computed(() => programs.value.reduce((prev, { major }) => prev || major === 'EDST', false))
    const EDSTContentFields = ref([])
    const contentFieldItems = ref([
      { value: 'EDLA', text: 'Language Arts' },
      { value: 'EDMA', text: 'Mathematics' },
      { value: 'EDSC', text: 'Science' },
      { value: 'EDSS', text: 'Social Studies' }
    ])
    watch(EDSTContentFields, () => {
      if (EDSTContentFields.value.length > 2) {
        EDSTContentFields.value.splice(2, 1)
      }
    })

    const isValid = computed(() => {
      // for (const { major } of programs.value) {
      //   if (major == null || major === '') return false
      // }
      // if (isEDSTMajor.value && EDSTContentFields.value.length < 2) return false
      return true
    })

    const form = ref(null)
    const formValid = ref(false)

    function getMajorDesc (major) {
      const rec = majorItems.value.find(({ value }) => value === major)
      if (rec) return rec.text
      else return major
    }
    function getAdvisor (major, advisor) {
      const rec = advisors[major].find(({ value }) => value === advisor)
      if (rec) return rec.text
      else return `Unable to find advisor`
    }

    function getConcentrations (major, conc) {
      const arr = []
      for (const c of conc) {
        const rec = concentrations[major].find(({ value }) => value === c)
        arr.push(rec ? rec.text : c)
      }
      return arr.join('; ')
    }

    function getMinorDesc (minors) {
      const arr = minorItems.value.filter(({ value }) => minors.includes(value))
      return arr
    }

    return {
      user,
      roles,
      required,
      dataLoaded,
      term,
      termLabel,
      current,
      changes,
      submission,
      status,
      programs,
      majorItems,
      majorToAdd,
      addAdvisor,
      addAdvisorOptions,
      addConcentrations,
      addConcentrationOptions,
      addMajorDialog,
      addMajor,
      changeMajorDialog,
      changeMajorTo,
      changeMajor,
      primaryItems,
      minor,
      minorItems,
      setInitialData,
      save,
      includeP12,
      P12Secondary,
      isEDSTMajor,
      EDSTContentFields,
      contentFieldItems,
      isValid,
      form,
      formValid,
      getMajorDesc,
      getAdvisor,
      getConcentrations,
      getMinorDesc
    }
  }
}

// function findDiffs (original, updated) {
//   const rem = original.filter((val) => !inArray(val, updated))
//   const add = updated.filter((val) => !inArray(val, original))
//   return { add, rem }
// }
</script>
